import { connect } from 'react-redux';
import Global from '../../../../store/global-selectors';
import * as Actions from '../../../../store/shipments/filtering/shipments.filtering.actions';
import FilterView from '../index';

const mapStateToProps = (state, ownProps) => {
  const activeFilterViewId = Global.selectShipmentsFilteringActiveFilterViewId(state);
  return {
    activeFilterViewId,
    isActive: activeFilterViewId === ownProps.filterViewId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onViewClick: (filterViewId) => {
      dispatch(Actions.switchActiveFilterView(filterViewId));
    },
    launchEditViewModal: () => {
      dispatch(Actions.launchEditViewModal());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterView);
